"use client"

import { cn } from "@/lib/utils"

interface WalletAddressProps {
  address: string
  truncate?: boolean
  className?: string
}

export function WalletAddress({
  address,
  truncate = false,
  className,
}: WalletAddressProps) {
  const truncateAddress = (addr: string) => {
    if (addr.length > 10) {
      return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`
    }
    return addr
  }

  const displayAddress = truncate ? truncateAddress(address) : address

  return (
    <span
      className={cn(
        "text-sm font-normal !select-text cursor-text",
        truncate && "truncate",
        className
      )}
      title={truncate ? address : undefined}
      style={{
        userSelect: "text",
        WebkitUserSelect: "text",
        MozUserSelect: "text",
        msUserSelect: "text",
      }}
    >
      {displayAddress}
    </span>
  )
}
